import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAndroidautoComponent } from './simple-icons-androidauto.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAndroidautoComponent ],
    exports:      [ SimpleIconsAndroidautoComponent ],
    bootstrap:    []
})
export class SimpleIconsAndroidautoModule {}
